import { Typography } from '@mui/material';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseDialog } from 'src/components/dialogs/base-dialog/base-dialog';
import { AttestationEditFormProps, AttestationsEditForm } from '../attestations-edit-form';

interface AttestationsEditDialogProps extends AttestationEditFormProps {
  title?: string;
  popDialog?: any;
}

export const AttestationsEditDialog: ComponentType<AttestationsEditDialogProps> = ({
  title: dialogTitle,
  id,
  date,
  popDialog,
  onSubmit,
  ...props
}) => {
  const { t } = useTranslation();
  const defaultTitle = !!id
    ? t('attestations.edit', 'Добавить расписание')
    : t('attestations.add', 'Редактировать расписание');
  const title = dialogTitle ? dialogTitle : defaultTitle;

  return (
    <BaseDialog {...{ ...props, popDialog }}>
      {title && (
        <Typography variant="h2" component="h6" mb={2}>
          {title}
        </Typography>
      )}
      <AttestationsEditForm {...{ id, date, onSubmit, onCancel: popDialog }} />
    </BaseDialog>
  );
};
